import { text, brandText, brandAltText, } from '@guardian/src-foundations/palette';
export const linkDefault = {
    link: {
        textPrimary: text.anchorPrimary,
        textPrimaryHover: text.anchorPrimary,
        textSecondary: text.anchorSecondary,
        textSecondaryHover: text.anchorSecondary,
    },
};
export const linkBrand = {
    link: {
        textPrimary: brandText.anchorPrimary,
        textPrimaryHover: brandText.anchorPrimary,
    },
};
export const linkBrandAlt = {
    link: {
        textPrimary: brandAltText.anchorPrimary,
        textPrimaryHover: brandAltText.anchorPrimary,
    },
};
//# sourceMappingURL=link.js.map
